import service from '@/service'
import urlManager from '@/urlManager'

const mutations = {
  SET_CONFIGURATION: 'SET_CONFIGURATION'
}

// TODO: move initiative related states from store.js to this file
/**
 * This is the store module for initiative
 */
export default {
  namespaced: true,
  state: () => ({
    filterConfiguration: null
  }),
  getters: {
    filterConfiguration: state => state.filterConfiguration
  },
  mutations: {
    [mutations.SET_CONFIGURATION]: (state, configuration) => {
      state.filterConfiguration = configuration
    }
  },
  actions: {
    async getFilterConfiguration({ commit }) {
      const response = await service.client.get(urlManager.filterConfigurations, {
        baseURL: '',
        transformResponse: JSON.parse
      })
      const config = response.data
      commit(mutations.SET_CONFIGURATION, config)
    },
    async summarizeInitiative(options, { orgId, initiativeId }) {
      const response = await service.client.get(urlManager.summarizeInitiative(orgId, initiativeId))
      return response.data.summary
    }
  }
}
